import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBannersService } from "redux/services/general_service";
import { motion, AnimatePresence } from "framer-motion";

const HomeBanners = () => {
  const dispatch = useDispatch();
  const { bannersList } = useSelector((state) => state.general);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    dispatch(getBannersService({ page: 1 }));
  }, [dispatch]);

  // Auto Slide
  useEffect(() => {
    if (!bannersList?.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === bannersList.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [bannersList]);

  if (!bannersList?.length) return null;

  const currentBanner = bannersList[currentIndex];

  return (
    <section className="py-16 bg-background">
      <div className="container">
        <div className="relative overflow-hidden rounded-2xl shadow-2xl group cursor-pointer">
          
          {/* Image */}
          <AnimatePresence mode="wait">
            <motion.img
              key={currentBanner.id}
              src={currentBanner.image}
              alt="banner"
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8 }}
              className="w-full h-[250px] md:h-[350px] lg:h-[420px] object-cover"
              onClick={() => {
                if (currentBanner.url) {
                  window.location.href = currentBanner.url;
                }
              }}
            />
          </AnimatePresence>

          {/* Overlay Gradient */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent pointer-events-none" />

          {/* Navigation Dots */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {bannersList.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  currentIndex === index
                    ? "w-6 bg-accent"
                    : "w-2 bg-white/60"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanners;